// Module
var code = "<react-component name=\"PosTaxRates\"></react-component>\n";
// Exports
module.exports = code;